import i18n from '@i18next/i18n';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import {
    TOOLBAR_TEXT,
    TOOLBAR_SHAPE,
    TOOLBAR_PICTURE,
    TOOLBAR_FORM,
    TOOLBAR_ADDGROUP,
    TOOLBAR_CHART,
} from '@src/framework/editor/src/img/pageIndex';
import { AnimType } from '@tencent/slide-sdk-model';
import { nodeTypes } from '@src/slide/domain/ui-model/element-modeles/property/animation/constant';

export const ELEMENT_ICON = {
    [UIModelType.SHAPE]: TOOLBAR_TEXT,
    [UIModelType.IMAGE]: TOOLBAR_PICTURE,
    [UIModelType.TABLE]: TOOLBAR_FORM,
    [UIModelType.CONNECTOR]: TOOLBAR_SHAPE,
    [UIModelType.GROUP]: TOOLBAR_ADDGROUP,
    [UIModelType.CHART]: TOOLBAR_CHART,
    // to do，需要更换图标
    [UIModelType.SMART_ART]: TOOLBAR_SHAPE,
};
export const ELEMENT_ICON_LIST = [TOOLBAR_TEXT, TOOLBAR_PICTURE, TOOLBAR_FORM, TOOLBAR_SHAPE, TOOLBAR_ADDGROUP];
export const ELEMENT_TYPE_TEXT = {
    [UIModelType.SHAPE]: i18n.t('文本'),
    [UIModelType.IMAGE]: i18n.t('图片'),
    [UIModelType.TABLE]: i18n.t('表格'),
    [UIModelType.CONNECTOR]: i18n.t('图形'),
    [UIModelType.GROUP]: i18n.t('组合'),
};

export const EFFECT_TYPE_TEXT = {
    [nodeTypes.CLICK_EFFECT]: i18n.t('单击时'),
    [nodeTypes.WITH_EFFECT]: i18n.t('与上一个同时'),
    [nodeTypes.AFTEREFFECT]: i18n.t('上一个之后'),
};

export const FLOAT_IN = 'float_in';
export const FLOAT_OUT = 'float_out';

export const animTypeMap = {
    [AnimType.FloatDownIn]: FLOAT_IN,
    [AnimType.FloatUpIn]: FLOAT_IN,
    [AnimType.FloatDownOut]: FLOAT_OUT,
    [AnimType.FloatUpOut]: FLOAT_OUT,
};

export const iconTypeMap = {
    [FLOAT_IN]: AnimType.FloatUpIn,
    [FLOAT_OUT]: AnimType.FloatUpOut,
};

export const ShapeTypeMap = {
    [AnimType.EntrShapeBox]: AnimType.EntrShapeCircle,
    [AnimType.EntrShapeDiamond]: AnimType.EntrShapeCircle,
    [AnimType.EntrShapePlus]: AnimType.EntrShapeCircle,
    [AnimType.ExitShapeBox]: AnimType.ExitShapeCircle,
    [AnimType.ExitShapeDiamond]: AnimType.ExitShapeCircle,
    [AnimType.ExitShapePlus]: AnimType.ExitShapeCircle,
};
